<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content class="content">
  @if (rows.length === 0) {
    <div class="empty">(No fields)</div>
  }

  @for (row of rows; track trackByKey($index, row)) {
    <div class="row">
      <div class="key">{{ row.key }}</div>
      <div class="value">{{ row.value }}</div>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="doneClicked()">Done</button>
</mat-dialog-actions>
